import React, { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import $ from "jquery";
import PropTypes from 'prop-types';

import { loader_image } from "../_components/Imagepath";
import {
  MenuItem,
} from '@mui/material';

const DailyProductionReportsGroupbyCaliber = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  // const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
// Extract query parameters
const location = useLocation();
   let season_id = localStorage.getItem("season_id");

const queryParams = new URLSearchParams(location.search);
const startDate = queryParams.get("start_date");
const endDate = queryParams.get("end_date");
//   useEffect(() => {
//         setPermission(FindModuleById(61)); 
// console.log(permission);

//     axios
//     .get(`/daily-production-reports/listing-groupby-caliber-details/${id}`, {
//       headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
//     })
//     .then((response) => {
//       if (response.data.code === 200) {
//         // setValue(response.data.data.calibres_details.caliber);
//         setData(response.data.data.calibres_details.caliber.productions);
//       }
//     })
//     .catch((error) => {
//       console.log(error);
//     });
//   }, [id]);
useEffect(() => {
  setPermission(FindModuleById(61));
  console.log(permission);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `/daily-production-reports/listing-groupby-caliber-details/${id+'_'+season_id}`, {
          params: {
            start_date: startDate || undefined,
            end_date: endDate || undefined
          },
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken
          }
      });

      if (response.data.code === 200) {
        setData(response.data.data.calibres_details.caliber.productions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  fetchData();
}, [id, startDate, endDate]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  const BarcodeCell = ({ row }) => (
    <a href={`/production-output-view/${row.original.id}`} className="">
      {row.original.barcode_number}
    </a>
  );
  
  BarcodeCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        barcode_number: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  };
  
  const CaliberCell = ({ row }) => {        
    const total_items = row.original.items || []; // Ensure it's an array
    const calibreDisplay = total_items.map(item => item.calibre).join(' / ');
  
    return <span>{calibreDisplay}</span>;
  };
  
  CaliberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            calibre: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };
  
  const columns = [
    {
      header: 'Barcode Number',
      accessorFn: (row) => `${row.barcode_number}`,
      Cell: BarcodeCell
    },
    {
      accessorKey: 'date_time',
      header: 'Date Time',
    },
    {
      header: 'Location',
      accessorFn: (row) => `${row.location_name ? row.location_name.title : ''}`,
    },
    {
      accessorKey: 'shift',
      header: 'Shift',
    },
    {
      accessorKey: 'shift_date',
      header: 'Shift Date',
    },
    {
      header: 'Order PO Number',
      accessorFn: (row) => `${row.order_detail ? row.order_detail.po_number : ''}`,
    },
    {
      header: 'Caliber',
      Cell: CaliberCell
    },
    {
      header: 'Pallet Type',
      accessorFn: (row) => `${row.pallet_type_title ? row.pallet_type_title.title : ''}`,
    },
    {
      header: 'Package Type',
      accessorFn: (row) => `${row.package_type ? row.package_type.title : ''}`,
    },
    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
  ];

  const editItem = (item)=>{
    window.location.href = "/production-output-edit/"+item;
  }

  const printPalletLabel = (item)=>{
       let season_id = localStorage.getItem("season_id");

    var id = item.id; 
    $("#loader-image2").removeClass('loader-hide');
  $("#loader-image2").addClass('loader-show');
  axios.get(`/production-output-pallet-label/pdf/${season_id+'-'+id}`, {
     responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
 }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let file_name = 'Pallet Label - '+item.barcode_number+'.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image2").addClass('loader-hide');
      $("#loader-image2").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });
   // alert(item);
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Output Group By Caliber</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-daily-reports">Production Daily Reports</Link>
                    </li>
                    <li className="breadcrumb-item active">
                       Production Output Group By Caliber
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Production Output Group By Caliber</h4>
                    <table className="table table-bordered">
                    {/* <tr>
                        <th className="p-3">Caliber</th>
                        <td className="p-3">{(value.calibre !="")?value.calibre:""}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Number Of pallets</th>
                        <td className="p-3">
                          {value.number_of_pallets ? value.number_of_pallets : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Quantity</th>
                        <td className="p-3">
                          {value.quantity ? value.quantity : ""}
                        </td>
                      </tr> */}
                      </table>
                   
                  </div>
                </div>
              </div>
            </div>

            
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Listing Productions Output</h4>
                    <div className="table-responsive">
                        <MaterialReactTable columns={columns} data={data} 
                          enableColumnOrdering
                          enablePinning
                          enableRowActions
                          //renderColumnActionsMenuItems 
                          renderRowActionMenuItems={({ row }) => [
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>,
                           <MenuItem key="view" onClick={() => printPalletLabel(row.original)}>
                           Print Pallet Label <img id="loader-image2" className="loader-image loader-hide" src={loader_image}/> 
                         </MenuItem>,
                       
                          ]}
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
         
          </div>
        </div>
      </div>
    </>
  );
};
export default DailyProductionReportsGroupbyCaliber;
